 :sm="6" :xs="6"<template>
    <div class="device-type-manange relative">
        <div class="buttons">
            <el-button @click="resetForm">重置</el-button>
            <el-button @click="search">筛选</el-button>
            <el-button :id="'managerAdd'" @click="addData">新增</el-button>
        </div>

        <!-- 表单开始 -->
        <el-row class="inputs mg-20" :gutter="20">
            <el-col :md="6" :lg="6" :xl="4" :sm="12" :xs="24">
                <span class="fs-14 pd-r-10">职称名称：</span>
                <el-input v-model="title_name" placeholder="职称名称模糊搜索"/>
            </el-col>
            <el-col :md="6" :lg="6" :xl="4" :sm="12" :xs="24">
                <span class="fs-14 pd-r-10">状态：</span>
                <el-select v-model="status" placeholder="请选择状态">
                    <el-option
                            v-for="item in allStatus"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                    ></el-option>
                </el-select>
            </el-col>
        </el-row>
        <!-- 表单结束 -->
        <div class="docker_buttons">
            <el-button type="primary" :id="'managerDownload'" @click="exportExcel">导出数据</el-button>
        </div>

        <el-table ref="multipleTable"
                  :data="tableData"
                  border
                  style="width: 100%">
<!--            <el-table-column prop="sort" label="排序" align="center" label-class-name="label"></el-table-column>-->
            <el-table-column prop="no" label="序号" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="title_name" label="职称名称" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="manager_number" label="健康管理助理数量" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="update_date" label="更新时间" align="center" label-class-name="label"></el-table-column>
            <el-table-column prop="status" label="状态" align="center" label-class-name="label"></el-table-column>
            <el-table-column
                    prop="address"
                    label="操作"
                    align="center"
                    label-class-name="label"
                    v-slot="scope"
            >
                <el-button :id="'managerEdit'" @click="goEdit(scope.row)"
                           type="text" size="mini">编辑
                </el-button>
                <el-button :id="'managerEdit'" @click="deleteData(scope.row)"
                           type="text" size="mini">删除
                </el-button>
                <el-button :id="'upDownArticle'" @click="startStopTitle(scope.row,2)"
                           v-if="scope.row.status_number==1"
                           type="text"
                           size="small">停用
                </el-button>
                <el-button :id="'upDownArticle'" @click="startStopTitle(scope.row,1)"
                           v-if="scope.row.status_number==2"
                           type="text"
                           size="small">启用
                </el-button>
                <el-button :id="'managerEdit'" @click="addManager(scope.row)"
                           type="text" size="mini">添加健康管理助理
                </el-button>
            </el-table-column>
        </el-table>
        <el-pagination
                class="mg-20 ta-r"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :page-sizes="[10, 25, 50, 100]"
                :total="total"
                :page-size="perpage"
                :current-page="page"
                @current-change="changePage"
                @size-change="changeSite"
        ></el-pagination>
    </div>
</template>
<script>
    import {export2Excel} from "@/utils/excel";
    import env from "@/api/env";
    import {check} from "@/utils/checkData";
    import {authUrlCheck} from "@/api/order";
    import {getUserInfos} from "@/utils/userInfos";

    export default {
        data() {
            return {
                role_id: 0,
                page: 1,
                perpage: 10,
                total: 0,
                tableData: [],
                allStatus: [
                    {
                        id: 1,
                        name: '启用'
                    },
                    {
                        id: 2,
                        name: '停用'
                    },
                ],
                title_name: '',
                status: '',
                is_submit: false,
            };
        },
        created() {
            let userInfo = getUserInfos()
            if (userInfo) {
                this.role_id = parseInt(userInfo.role_id)
            }
            localStorage.setItem('prev_page', 'managertitle_list')
        },
        mounted() {
            // 获取职称列表
            this.getList();
        },
        methods: {
            // 获取所有医生
            getList() {
                let params = {
                    servername: 'Ruyi_AdminOperateServices',
                    method: 'managerTitleListing',
                    pageinfo: {
                        page: this.page,
                        perpage: this.perpage,
                    },
                    params: {
                        title_name: this.title_name,
                        status: this.status,
                    }
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        this.is_submit = false;
                        return;
                    }
                    for (var i = 0; i < res.data.data.list.length; i++) {
                      // 序号
                      res.data.data.list[i].no = (this.page - 1) * this.perpage + i + 1
                        switch (res.data.data.list[i].status) {
                            case '1':
                                res.data.data.list[i].status = '启用';
                                res.data.data.list[i].status_number = 1;
                                break;
                            case '2':
                                res.data.data.list[i].status = '停用';
                                res.data.data.list[i].status_number = 2;
                                break;
                        }
                    }
                    this.tableData = res.data.data.list;
                    this.total = res.data.data.page.count;
                    this.is_submit = false;
                }).catch(()=>{
                    this.is_submit = false;
                }).finally(() => {
                    this.is_submit = false;
                });
            },

            // 改变每页条数
            changeSite(index) {
                this.perpage = index;
                this.getList();
            },

            //更换页码
            changePage(index) {
                this.page = index;
                this.getList();
            },

            // 重置按钮
            resetForm() {
                if (this.is_submit) {
                    // 重复提交提醒
                    this.$message({
                        type: "warning",
                        message: '正在处理请求，请不要重复操作',
                        duration: 1500,
                    });
                    return;
                }
                this.is_submit = true;
                this.title_name = "";
                this.status = "";
                this.page = 1;
                this.getList();
            },

            // 搜索
            search() {
                if (this.is_submit) {
                    // 重复提交提醒
                    this.$message({
                        type: "warning",
                        message: '正在处理请求，请不要重操作',
                        duration: 1500,
                    });
                    return;
                }
                this.is_submit = true;
                this.page = 1;
                this.getList();
            },

            // 编辑
            goEdit(data) {
                this.$router.push({
                    name: "managerTitleEdit", params: {
                        id: data.id,
                        title_name: data.title_name,
                        sort: data.sort,
                        status: parseInt(data.status_number),
                    }
                });
            },

            // 新增
            addData() {
                this.$router.push({name: "managerTitleAdd", params: {}});
            },

            deleteData(data) {
                if (this.is_submit) {
                    // 重复提交提醒
                    this.$message({
                        type: "warning",
                        message: '正在处理请求，请不要重复操作',
                        duration: 1500,
                    });
                    return;
                }
                this.is_submit = true;
                this.$confirm('确定删除该健康管理助理职称吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let params = {
                        servername: 'Ruyi_AdminOperateServices',
                        method: 'deleteManagerTitle',
                        params: {
                            id: data.id,
                        }
                    };
                    this.$api.service(params).then(res => {
                        if (!check(res)) {
                            this.is_submit = false;
                            return;
                        }
                        if (res.data.code != '0') {
                            this.$message({
                                type: "error",
                                message: res.data.msg,
                                duration: 1500,
                            });
                        } else {
                            this.$message({
                                type: "success",
                                message: '删除成功',
                                duration: 1500,
                            });
                        }
                        this.getList();
                        this.is_submit = false;
                    }).catch(() => {
                        this.is_submit = false;
                    }).finally(() => {
                        this.is_submit = false;
                    });
                }).catch(() => {
                    this.is_submit = false;
                }).finally(() => {
                    this.is_submit = false;
                });
            },

            // 启用停用公司
            startStopTitle(data, status) {
                if (this.is_submit) {
                    // 重复提交提醒
                    this.$message({
                        type: "warning",
                        message: '正在处理请求，请不要重复操作',
                        duration: 1500,
                    });
                    return;
                }
                this.is_submit = true;
                if (status == '1') {
                    var message = '确定启用该职称吗？';
                }
                if (status == '2') {
                    var message = '确定停用该职称吗？';
                }
                this.$confirm(message, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let params = {
                        servername: 'Ruyi_AdminOperateServices',
                        method: 'startStopManagerTitle',
                        pageinfo: {
                            page: this.page,
                            perpage: this.perpage,
                        },
                        params: {
                            id: data.id,
                            status: status
                        }
                    };
                    this.$api.service(params).then(res => {
                        if (!check(res)) {
                            this.is_submit = false;
                            return;
                        }
                        this.$message({
                            type: "success",
                            message: '修改成功',
                            duration: 1500,
                        });
                        this.getList();
                        this.is_submit = false;
                    }).catch(() => {
                        this.is_submit = false;
                    }).finally(() => {
                        this.is_submit = false;
                    });
                }).catch(() => {
                    this.is_submit = false;
                }).finally(() => {
                    this.is_submit = false;
                });
            },
            // 跳转到添加健康管理助理
            addManager(data) {
                if (data.status_number == '2') {
                    this.$message.error('请先启用该数据！');
                    return;
                }
                if (this.role_id > 1) {
                    if (!authUrlCheck('/admin/manager/ManagerAdd', this.$store.getters.authUrl)) {
                        return;
                    }
                }
                this.$router.push({
                    name: "doctorAdd", params: {
                        doctor_title_id: data.id
                    }
                });
                return;
            },
            // 导出数据
            exportExcel() {
                if (this.is_submit) {
                    // 重复提交提醒
                    this.$message({
                        type: "warning",
                        message: '正在处理请求，请不要重复操作',
                        duration: 1500,
                    });
                    return;
                }
                this.is_submit = true;
                let params = {
                    servername: 'Ruyi_AdminOperateServices',
                    method: 'exportManagerTitle',
                    params: {
                        title_name: this.title_name,
                        status: this.status,
                    },
                };
                let colums_list = [
                    {title: "ID", key: "id"},
                    {title: "职称名称", key: "title_name"},
                    {title: "健康管理助理数量", key: "manager_number"},
                    {title: "更新时间", key: "update_date"},
                    {title: "状态", key: "status"},
                ];
                let export_data = [];
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        this.is_submit = false;
                        return;
                    }

                    let res_data = res.data;
                    if (parseInt(res_data.code) != 0) {
                        this.$message.error(res_data.msg);
                        this.is_submit = false;
                        return false;
                    }

                    for (let i = 0; i < res_data.data.length; i++) {
                        let status;
                        switch (res_data.data[i].status) {
                            case '1':
                                status = '启用';
                                break;
                            case '2':
                                status = '停用';
                                break;
                        }

                        let item = {
                            id: res_data.data[i].id,
                            title_name: res_data.data[i].title_name,
                            manager_number: res_data.data[i].manager_number,
                            update_date: res_data.data[i].update_date,
                            status: status,
                        };
                        export_data.push(item);
                    }
                    export2Excel(colums_list, export_data, "导出职称");
                    let _that = this
                    setTimeout(function () {
                        _that.is_submit = false;
                    }, 1500)
                }).finally(() => {
                    this.is_submit = false;
                });
            }


        }
    };
</script>
<style lang="scss">
    @import "@/styles/common.scss";

    .docker_buttons {
        float: right;
        margin: 30px 0px 8px 0px;

        .el-button {
            width: 150px;
            height: 32px;
            line-height: 7px;
        }
    }
    .el-col{
        margin-bottom: 10px;
        input{
            width: 100%;
        }
    }
</style>
